<template>
  <div class="login">
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <br />
        <br />
        <br />
        <br />
        <br />
        <h1>个人中心</h1>
        <br />
        <br />
        <br />
        <van-field
          v-model="phone"
          name="phone"
          placeholder="请输入手机号码"
          clearable
          type="tel"
          maxlength="11"
          :rules="[{ pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, required: true, message: '手机号格式错误' }]"
          style="font-size: 16px;padding:20px 16px;"
        />
        <van-field
          v-model="code"
          center
          name="code"
          type="digit"
          required
          :rules="[{ required: true, message: '请输入验证码' }]"
          clearable
          label="验证码"
          placeholder="请输入验证码"
          :border="false"
          use-button-slot
          maxlength="6"
          style="font-size: 16px;"
        >
          <van-button slot="button" size="small" type="primary" native-type="button" @click="gainCode" style="font-size: 14px;">{{ time }}</van-button>
        </van-field>
      </van-cell-group>
      <br />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" style="font-size: 18px;" size="large"><b>登录</b></van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
    data(){
      return{
        code: '',
        phone: '',
        isClick: true,
        time: '获取验证码',
      }
    },
    created() {
      this.isMeegtingId()

    },
    methods:{
      isMeegtingId(){
        if(this.$route.query.meetingId == '' || this.$route.query.meetingId == null || this.$route.query.meetingId == 'null' || this.$route.query.meetingId == 'undefined'){
          this.$toast.fail('访问地址错误');
          return false;
        }else{
          sessionStorage.setItem('meetingId',this.$route.query.meetingId);
          this.$cookies.set('meetingId',this.$route.query.meetingId);
          var hyMeetingId = this.$route.query.meetingId;
          var ydlPhone = this.$route.query.phone;
          if(ydlPhone){
            this.axios('/api/appweb/login/getTokenForPreLogin/'+ydlPhone).then(res=>{
              console.log(res.data.data);
              if(res.data.status == 200){
                localStorage.setItem('sessionGrzxToken_'+hyMeetingId,res.data.data);
                this.$router.push("/personal/index");
              }
            })
          }
		  // alert('login'+hyMeetingId)
          var token = localStorage.getItem('sessionGrzxToken_'+hyMeetingId);
		  // alert(token)
          if(token){
            this.$router.push("/personal/index");
          }
        }
      },
      // 获取验证码
      gainCode() {

        if (this.isClick) {
          if (/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.phone)) {

              this.axios.get('/api/appweb/login/sendLoginMessage/'+this.$route.query.meetingId+'/' + this.phone).then(res => {
                let data = res.data;
                //console.log(data)
                if (data.status == 200) {
                  this.$toast.success(data.message);
                }else{
                  this.$toast.fail(data.message);
                }
              });
              this.isClick = false;
              let s = 60;
              this.time = s + '秒';
              let interval = setInterval(() => {
                s--;
                this.time = s + '秒';
                if (s < 0) {
                  this.time = '重新获取';
                  this.isClick = true;
                  clearInterval(interval);
                }
              }, 1000);

          } else {
            this.$toast.fail('请输入正确的手机号码');
          }
        }
      },
      onSubmit(values) {
        console.log(values);
        sessionStorage.setItem('phone',values.phone);
       this.axios.post('/api/auth/webLogin/tokenByCode',values).then(res=>{
         console.log(res)
         if (res.data.status == 200) {
           var hyMeetingId = this.$route.query.meetingId;
             localStorage.setItem('sessionGrzxToken_'+hyMeetingId,res.data.data);
            if(sessionStorage.getItem('openid')){
              this.$router.push("/personal/index");
            }else{
              this.$router.push("/getWxOpenId/grzx");
            }
         } else {
            this.$toast.fail(res.data.message);
             return false;
         }
       })
      }
    }
  }
</script>

<style scoped="scoped">
.login {
  height: 100vh;
  background: #ddd url(../../assets/images/grzxloginbg.jpg);
  background-size: cover;
}
.van-cell-group {
  background: none;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
.login h1 {
  text-align: center;
  line-height: 40px;
  color: #fff;
  margin: 0;
}
.van-cell {
  margin-bottom: 20px;
  padding: 15px 16px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Personal/login.vue